module.exports = __webpack_public_path__ + "img/strawberry-cake.c6d5cdfb.webp";